import { render, staticRenderFns } from "./UploadImgone.vue?vue&type=template&id=a2dc7288&scoped=true&"
import script from "./UploadImgone.vue?vue&type=script&lang=js&"
export * from "./UploadImgone.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgone.vue?vue&type=style&index=0&id=a2dc7288&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2dc7288",
  null
  
)

export default component.exports